import {useEffect, useState} from "react";
import UrlHelper from "../../core/utils/url-helper";
import LayoutWithSider from "../../core/components/layout/layout-with-sider/LayoutWithSider";
import ApiService from "../../core/service/api-service";
import {Tabs, Button} from "antd";
import ViewerPanel from "./ViewerPanel";
import {CloseOutlined, FullscreenOutlined} from "@ant-design/icons";

export default function StudyOHIFPanel() {
    const [activeStudyId, setActiveStudyId] = useState('')
    const [studies, setStudies] = useState([])

    const loadStudies = async () => {
        const list = UrlHelper.getUrlParam(window.location.search, 'studies');
        let load = false
        for(const id of list.split('_')) {
            const res = await ApiService.Study.Get(parseInt(id))
            if(!res.success)
                continue
            console.log(res.data)
            const url = ApiService.Dicom.GetStudyDicomMetadata(res.data.id)
            const item = {
                name: (
                    <div style={{display: 'flex', alignItems: 'start', gap: 4}}>
                        <div>
                            <b>{res.data.patient.name}/{res.data.modality.name}</b>
                            <br/>
                            {res.data.accessionNumber}
                            <br/>
                            {new Date(res.data.createdAt).toLocaleDateString()}
                        </div>
                        <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column', gap: 4}}>
                            <Button
                                style={{width: 20, height: 20}}
                                icon={<CloseOutlined />}
                                onClick={() => setStudies(studies.filter(x => x.studyId !== id))}
                            />
                            <Button
                                style={{width: 24, height: 24}}
                                icon={<FullscreenOutlined />}
                                onClick={() => {
                                    const elem = document.getElementById(`panel_${id}`);
                                    if (elem.requestFullscreen) {
                                        elem.requestFullscreen();
                                    } else if (elem.mozRequestFullScreen) { /* Firefox */
                                        elem.mozRequestFullScreen();
                                    } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
                                        elem.webkitRequestFullscreen();
                                    } else if (elem.msRequestFullscreen) { /* IE/Edge */
                                        elem.msRequestFullscreen();
                                    }
                                }}
                            />
                        </div>
                    </div>
                ),
                studyId: id,
                received: new Date(res.data.createdAt),
                url: `${window?.AppSettings?.server?.ohif}/viewer/dicomjson?url=${url}`,
            }
            setStudies((prev) => [...prev, item])
            if(!load)
            {
                setActiveStudyId(id)
                load = true
            }
            // console.log(res)
        }
    }

    useEffect(() => {
        loadStudies()
        const interval = setInterval(() => {
            const header = document.getElementById('site-header')
            if(header) {
                header.remove()
                clearInterval(interval)
            }
        }, 250)
    }, []);

    return (
        <>
            <Tabs
                type="card"
                onChange={(key) => {
                    setActiveStudyId(key)
                }}
                activeKey={activeStudyId}
                onEdit={(e) => {
                    if(e) {
                        setStudies(studies.filter(x => x.studyId !== e))
                    }
                }}
            >
                {
                    studies.map(x => {
                        return (
                            <Tabs.TabPane tab={x.name} key={x.studyId}>
                                <div id={`panel_${x.studyId}`}>
                                    <ViewerPanel src={x.url} />
                                </div>
                            </Tabs.TabPane>
                        )
                    })
                }
            </Tabs>
        </>
    )
}